module.exports = __webpack_public_path__ + "static/media/Misconfigured Buckets or file servers.373b69f2.png";